<template>
  <div class="navbody" >
    <el-divider content-position="left">知识点列表管理</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.category_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="标题" prop="nav">
            <el-input v-model="categoryForm.nav" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="层级" prop="categoryId">
            <div style="display: flex; flex-direction: row">
              <div style="margin-right: 0.2rem; width: 100%">
                <el-cascader
                  clearable
                  filterable
                  v-model="categoryForm.categoryId"
                  :options="options"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'category_name',
                    value: 'id',
                    checkStrictly: true,
                  }"
                  @click.native="loadCategory"
                  size="mini"
                  style="width: 100%"
                  ref="cascader"
                ></el-cascader>
                <!-- @change="handleChangeCascader" -->
              </div>
            </div>
            <i
              class="el-icon-message-solid"
              style="color: #e6a23c; font-size: small"
              >不选分类就视为顶级分类！</i
            >
          </el-form-item>
          <el-form-item label="链接地址" prop="url">
            <el-input v-model="categoryForm.url" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="icon">
            <el-input v-model="categoryForm.icon" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input v-model="categoryForm.desc" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="image">
            <div style="display: flex; flex-direction: row">
              <div style="margin-right: 0.2rem; width: 100%">
                <el-input
                  v-model.trim="categoryForm.image"
                  size="mini"
                  disabled
                  placeholder="选择图片"
                  :title="categoryForm.image"
                ></el-input>
              </div>
              <div>
                <el-button size="mini" type="primary" @click="openImgListDialog"
                  >选择图片</el-button
                >
              </div>
            </div>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="categoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          :rules="rules"
          ref="editCategoryForm"
          label-width="100px"
        >
          <el-form-item label="名称" prop="categoryId">
            <el-input
              v-model="editCategoryForm.categoryId"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="链接地址" prop="url">
            <el-input v-model="editCategoryForm.url" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="icon">
            <el-input v-model="editCategoryForm.icon" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input v-model="editCategoryForm.desc" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="image">
            <div
              style="
                display: flex;
                flex-direction: row;
                max-width: 600px;
                overflow: auto;
              "
            >
              <div
                style="display: inline-block"
                v-for="i in editCategoryForm.srcList"
                :key="i.id"
              >
                <div style="white-space: nowrap">
                  <el-image
                    title="点击查看大图"
                    style="width: 100px; height: 100px"
                    :src="i.url"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                  <div
                    @click="delPic(i.id)"
                    title="删除"
                    style="
                      border-radius: 50px;
                      width: 15px;
                      height: 15px;
                      border: 1px solid #f56c6c;
                      display: inline-block;
                      vertical-align: bottom;
                      text-align: center;
                      line-height: 15px;
                      cursor: pointer;
                      font-size: xx-small;
                      margin-right: 0.2rem;
                    "
                  >
                    X
                  </div>
                </div>
                <div
                  style="
                    margin: 0 auto;
                    text-align: center;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 50px;
                    overflow: hidden;
                  "
                  :title="i.name"
                >
                  {{ i.name }}
                </div>
              </div>
              <div>
                <el-button
                  size="mini"
                  type="primary"
                  @click="openImgListDialog(1)"
                  >选择图片</el-button
                >
              </div>
            </div>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="ifDisplay"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-dialog
      :visible.sync="imgListdialog"
      :before-close="handleClose_imgListdialog"
      fullscreen
    >
      <span
        style="color: #409eff; font-size: xx-large; font-weight: bold"
        slot="title"
        >选择图片</span
      >
      <span style="color: #e6a23c; display: inline-block; margin-bottom: 0.1rem"
        ><i class="el-icon-message-solid">若无合适的图片，可以先上传</i></span
      >
      <el-upload
        action="https://weixin.qiyehuo.com/api/knowledge_hierarchy/up_file"
        :headers="headers"
        multiple
        ref="uploadMutiple"
        :file-list="fileList"
        :limit="limit"
        :show-file-list="false"
        :before-upload="beforeAvatarUpload"
        :on-success="handleAvatarSuccess"
      >
        <!-- :on-preview="handlePictureCardPreview" -->
        <!-- :on-remove="handleRemove" -->
        <!-- :on-change="handleAvatarChange" -->

        <el-button size="mini" type="primary">点击上传</el-button>
      </el-upload>

      <div style="padding: 0.2rem 0.5rem">
        <el-col
          :span="6"
          v-for="item in navImages"
          :key="item.id"
          style="margin-top: 0.5rem; text-align: center"
        >
          <div style="margin-bottom: 0.2rem">
            <label>
              <img
                :src="item.url"
                alt=""
                width="300px"
                height="300px"
                style="cursor: pointer"
              />
              <input
                ref="imgref"
                type="checkbox"
                :data-id="item.id"
                :data-name="item.name"
                style="vertical-align: bottom"
              />
              <div
                style="
                  margin: 0.2rem auto;
                  text-align: center;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 50px;
                  overflow: hidden;
                "
                :title="item.name"
              >
                {{ item.name }}
              </div>
            </label>
          </div>
        </el-col>
      </div>
      <div
        style="
          clear: both;
          margin-top: 0.25rem;
          text-align: right;
          padding-right: 0.2rem;
        "
      >
        <el-button size="mini" type="primary" @click="choosedImg"
          >确定</el-button
        >
      </div>
      <div
        style="margin-top: 0.25rem; text-align: right; padding: 0.2rem 0.5rem"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="nowPage_in"
          :page-sizes="[16, 48, 144]"
          :page-size="pageSize_in"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total_in"
          background
        >
        </el-pagination>
      </div>
    </el-dialog>
    <el-table
      :data="categoryData"
      ref="categoryData"
      max-height="650"
      style="width: 100%; margin-top: 10px"
      row-key="id"
      @cell-dblclick="tabClick"
      :row-class-name="tableRowClassName"
      :cell-class-name="tableCellClassName"
      @expand-change="change"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
      @row-click="device_detail"
    >
      <!-- <el-table-column prop="id" label="ID"> </el-table-column> -->
      <el-table-column prop="category_name" label="名称"> </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSortC(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        width="450"
        prop="url"
        label="链接地址"
        show-overflow-tooltip
      >
      <template slot-scope="scope">
          <span v-if="scope.row.index === clickRow && scope.column.index === clickCell">
            <el-input
              ref="editInput"
              v-model="scope.row.url"
              maxlength="300"
              size="mini"
              @blur="inputBlur(scope.row)"
            />
          </span>
          <span v-else>{{ scope.row.url }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="icon"
        label="图标"
        show-overflow-tooltip
        >
        <template slot-scope="scope">
          <span v-if="scope.row.index === clickRow && scope.column.index === clickCell">
            <el-input
              ref="editInput"
              v-model="scope.row.icon"
              maxlength="300"
              size="mini"
              @blur="inputBlur(scope.row)"
            />
          </span>
          <span v-else>{{ scope.row.icon }}</span>
        </template></el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadioC(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-popconfirm
                  cancel-button-text="取消"
                  confirm-button-text="确认"
                  icon="el-icon-question"
                  icon-color="red"
                  title="您确认删除当前及其全部下级吗"
                  @onConfirm="deleRow"
                >
                <el-button
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                >
                </el-button>
            </el-popconfirm>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="添加子级" placement="top">
            <el-button
              @click.native.prevent="addRow(scope.row, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-circle-plus"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'OfficialNav',
  data () {
    var categoryId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      callback()
    }
    return {

      clickRow: null,
      clickCell: null,
      tabClickLabel: '',
      getColumn: null,
      getColumnValue: null,
      editType: 0,
      needAddImg: [],
      pageSize_in: 16,
      nowPage_in: 1,
      total_in: 0,
      npage_in: 1,
      mover: [],
      checkedImages: [],
      navImages: [],
      headers: {
        Authorization: localStorage.getItem('token')
      },
      fileList: [],
      limit: 10,
      needUrl: [],
      imgListdialog: false,
      addAddressForm: {
        category_name: '',
        url: '',
        icon: '',
        display: false,
        image: '',
        desc: ''
      },
      searchArr: {
        category_id: ''
      },
      loadC: [],
      npage: 1,
      needRow: '',
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      options: [],
      category: '',
      editId: '',
      categoryForm: {
        nav: '',
        categoryId: [],
        category_name: '',
        display: false,
        url: '',
        icon: 'icon-mc-xzsz',
        image: '',
        desc: ''
      },
      editCategoryForm: {
        nav: '',
        categoryId: '',
        category_name: '',
        display: false,
        image: '',
        url: '',
        icon: '',
        desc: '',
        srcList: []
      },
      rules: {
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ],
        nav: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        category_name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { max: 100, message: '分类名不超过100字符', trigger: 'blur' }
        ],
        url: [{ max: 200, message: '链接地址不超过200字符', trigger: 'blur' }],
        icon: [{ max: 100, message: '图标不超过200字符', trigger: 'blur' }],
        desc: [{ max: 150, message: '描述不超过150字符', trigger: 'blur' }]
      }
    }
  },
  watch: {
    'categoryForm.categoryId': {
      handler () {
        if (this.$refs.cascader) {
          this.$refs.cascader.dropDownVisible = false
        }
      }
    }
  },
  methods: {
    // 控制input显示 row 当前行 column 当前列
    tabClick (row, column, cell, event) {
      this.clickRow = row.index
      this.clickCell = column.index
      this.tabClickLabel = column.label
    },
    // 把每一行的索引放进row
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },

    // 把每一列的索引放进column
    tableCellClassName ({ column, columnIndex }) {
      column.index = columnIndex
    },

    // 失去焦点初始化
    inputBlur (row) {
      if (this.tabClickLabel === '链接地址') {
        this.getColumn = 'url'
        this.getColumnValue = row.url
      } else if (this.tabClickLabel === '图标') {
        this.getColumn = 'icon'
        this.getColumnValue = row.icon
      }
      this.$axios
        .get('api/knowledge_hierarchy/doubleedit', {
          params: {
            id: row.id,
            getColumn: this.getColumn,
            getColumnValue: this.getColumnValue
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.clickRow = null
            this.clickCell = null
            this.tabClickLabel = ''
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch()
    },
    loadTable () {
      this.$axios
        .get('api/knowledge_hierarchy/index', {
          params: {
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.loadRadio()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    deleRow () {
      setTimeout(() => {
        if (!this.editId) return false
        this.$axios
          .get('api/knowledge_hierarchy/del', {
            params: {
              id: this.editId
            }
          })
          .then(({ data }) => {
            if (data.code === 0) {
              this.categoryData = data.data.data
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    editRow (index, data) {
      // this.needRow = index
      setTimeout(() => {
        if (!this.editId) return false
        this.$axios
          .get('api/knowledge_hierarchy/show', {
            // params: {
            //   id: data[index].id
            // }
            params: {
              id: this.editId
            }
          })
          .then(({ data }) => {
            if (data.code === 1) {
              if (data.data.display === 1) {
                this.ifDisplay = false
              } else {
                this.ifDisplay = true
              }
              this.editCategoryForm.categoryId = data.data.category_name
              this.editCategoryForm.url = data.data.url
              this.editCategoryForm.icon = data.data.icon
              this.editCategoryForm.desc = data.data.desc
              this.editCategoryForm.srcList = data.data.img
              this.category = data.data.id
            }
          })
          .catch()
        this.categoryEditDrawer = true
      })
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/knowledge_hierarchy/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      this.npage = 1
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryForm.nav = ''
      this.categoryForm.categoryId = []
      this.categoryForm.category_name = ''
      this.categoryForm.display = false
      this.categoryForm.url = ''
      this.categoryForm.icon = 'icon-mc-xzsz'
      this.categoryForm.image = ''
      this.categoryForm.desc = ''
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    addRow (row, data) {
      this.categoryForm.nav = ''
      this.categoryForm.categoryId = []
      this.categoryForm.category_name = ''
      this.categoryForm.display = false
      this.categoryForm.url = ''
      this.categoryForm.icon = 'icon-mc-xzsz'
      this.categoryForm.image = ''
      this.categoryForm.desc = ''
      var arr = []
      if (row.parents !== null) {
        row.parents.forEach((item, index) => {
          arr.push(parseInt(item))
        })
      }
      setTimeout(() => {
        arr.push(parseInt(this.editId))
      })
      this.categoryForm.categoryId = arr
      this.loadCategory()
      this.categoryIndrawer = true
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/knowledge_hierarchy/store', {
              category_name: this.categoryForm.nav,
              parents: this.categoryForm.categoryId,
              url: this.categoryForm.url,
              icon: this.categoryForm.icon,
              desc: this.categoryForm.desc,
              img_id: this.needAddImg,
              display: this.categoryForm.display === false ? 1 : 0
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.needAddImg = []
                this.categoryForm.categoryId = []
                this.categoryIndrawer = false
                this.categoryData = data.data.data
                this.resetForm('categoryForm')
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      setTimeout(() => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$axios
              .put('api/knowledge_hierarchy/edit', {
                // id: this.category,
                id: this.editId,
                category_name: this.editCategoryForm.categoryId,
                url: this.editCategoryForm.url,
                icon: this.editCategoryForm.icon,
                desc: this.editCategoryForm.desc,
                display: this.ifDisplay === false ? 1 : 0
              })
              .then(res => {
                const { data } = res
                if (data.code === 1) {
                  this.$message.success(data.msg)
                  this.categoryEditDrawer = false
                  this.categoryData = data.data.data
                  // this.loadTable()
                  // this.toggleRowExpansion_forAll(this.categoryData, false)
                  // if (this.loadC.length > 0) {
                  //   this.loadAll(this.loadC)
                  // }
                  // setTimeout(() => {
                  //   this.$refs.categoryData.toggleRowExpansion(this.needRow, false)
                  // })
                } else {
                  this.$message.error(data.msg)
                }
              })
              .catch()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      })
    },
    editListRadioC (row) {
      setTimeout(() => {
        this.$axios
          .put('api/knowledge_hierarchy/listshow', {
            id: this.editId,
            display: this.ListIfDisplay[row.id] === false ? 1 : 0
          })
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    setSortC (row) {
      setTimeout(() => {
        if (isNaN(this.listSort[row.id])) {
          this.$message.error('排序值为数字！')
          return false
        }
        this.$axios
          .put('api/knowledge_hierarchy/setsort', {
            id: this.editId,
            sort: this.listSort[row.id]
          })
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    clearSelf () {
      this.resetForm('addAddressForm')
    },
    loadCategory () {
      this.$axios
        .get('api/knowledge_hierarchy/get_cate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.options = data.data
          }
        })
        .catch()
    },
    device_detail (val) {
      // this.needRow = val
      this.editId = val.id
    },
    loadRadioC (c) {
      c.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSortC (c) {
      c.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    change (v1, v2) {
      if (v2) {
        this.loadC = v1.children
        var cChildren = v1.children
        this.loadRadioC(cChildren)
        this.loadSortC(cChildren)
      } else {
        this.loadC = []
        this.cChildren = []
      }
    },
    loadAll (c) {
      this.loadRadioC(c)
    },
    // toggleRowExpansion_forAll (data, isExpansion) {
    //   data.forEach(item => {
    //     this.$refs.categoryData.toggleRowExpansion(item, isExpansion)
    //     if (item.children !== undefined && item.children !== null) {
    //       this.toggleRowExpansion_forAll(item.children, isExpansion)
    //     }
    //   })
    // },
    openImgListDialog (type = 0) {
      if (type === 1) this.editType = 1
      this.copyAddressFrom = this.addAddressForm
      this.loadNavImage()
      this.imgListdialog = true
    },
    handleClose_imgListdialog (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.npage_in = 1
          this.clearChoosed()
          done()
        })
        .catch(_ => {})
    },
    // 修改或2个上传组件可以共用before
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml'
      const isLt100M = file.size / 1024 / 1024 < 100

      if (!isJPG) {
        this.$message.error('上传图片格式为JPG或PNG!')
        return false
      }
      if (!isLt100M) {
        this.$message.error('上传总大小不能超过 100MB!')
        return false
      }
      // return isJPG && isLt2M
    },
    // 成功方法2个组件不可共用，修改可共用但要清空
    handleAvatarSuccess (res, file) {
      // if (res.code === 1) {
      //   this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      // }
      // this.imageUrl = URL.createObjectURL(file.raw)
      this.loadNavImage()
    },
    loadNavImage () {
      this.$axios
        .get(
          'api/knowledge_hierarchy/show_img?page=' +
            this.npage_in +
            '&perPage=' +
            this.pageSize_in
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.navImages = data.data.data
            this.total_in = data.data.total
          }
        })
        .catch()
    },
    // 成功方法2个组件不可共用，修改可共用但要清空
    handleAvatarChange (res, file) {
      this.fileList = file
      this.change = true
    },
    // 修改或2个上传组件可以共用
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 成功方法2个组件不可共用，修改可共用但要清空
    handleRemove (file, fileList) {
      // 这是删除服务器上的文件，需要的话自行打开
      // this.axios.get('api/pay/del_pic?file=' + file.response.url).then(({data}) => {
      // }).catch()
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
      this.change = true
    },
    choosedImg () {
      var type = this.editType
      var imgArr = this.$refs.imgref
      var img = imgArr.map(item => {
        if (item.checked) {
          return { id: item.dataset.id, name: item.dataset.name }
        }
      })
      var imgs = img.filter(function (i) {
        return i
      })
      if (type === 1) {
        if (imgs.length > 0) {
          var imagesS = []
          var nameS = []
          imgs.map(i => {
            imagesS.push(i.name)
            nameS.push(i.id)
          })
          this.$axios
            .post('api/knowledge_hierarchy/add_img', {
              id: this.editId,
              imgId: nameS
            })
            .then(({ data }) => {
              if (data.code === 1) {
                this.editType = 0
                this.loadEdit()
                this.$message.success(data.msg)
              }
            })
            .catch()
          this.needAddImg = nameS
          this.clearChoosed()
          this.npage_in = 1
          this.imgListdialog = false
        }
      } else {
        if (imgs.length > 0) {
          var images = []
          var name = []
          imgs.map(i => {
            images.push(i.name)
            name.push(i.id)
          })
          this.needAddImg = name
          this.categoryForm.image = images.join(';')
          this.clearChoosed()
          this.npage_in = 1
          this.imgListdialog = false
        }
      }
    },
    clearChoosed () {
      var imgArr = this.$refs.imgref
      imgArr.map(item => {
        item.checked = false
      })
    },
    delPic (id) {
      setTimeout(() => {
        this.$axios
          .delete('api/knowledge_hierarchy/del_img?id=' + this.editId + '&imgId=' + id)
          .then(({ data }) => {
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadEdit()
            }
          })
          .catch()
      })
    },
    loadEdit () {
      setTimeout(() => {
        if (!this.editId) return false
        this.$axios
          .get('api/knowledge_hierarchy/show', {
            // params: {
            //   id: data[index].id
            // }
            params: {
              id: this.editId
            }
          })
          .then(({ data }) => {
            if (data.code === 1) {
              if (data.data.display === 1) {
                this.ifDisplay = false
              } else {
                this.ifDisplay = true
              }
              this.editCategoryForm.categoryId = data.data.category_name
              this.editCategoryForm.url = data.data.url
              this.editCategoryForm.icon = data.data.icon
              this.editCategoryForm.desc = data.data.desc
              this.editCategoryForm.srcList = data.data.img
              this.category = data.data.id
            }
          })
          .catch()
      })
    }
  },
  computed: {
    srcList () {
      if (this.editCategoryForm.srcList.length > 0) {
        var arr = this.editCategoryForm.srcList.map(item => {
          return item.url
        })
        return arr
      }
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
  },
}
</script>

<style scoped lang="stylus">
.el-drawer__wrapper
  .el-drawer
    overflow-y: auto
.navbody
  margin-left: 3.6rem;
  padding: 1.82rem 0.4rem 0.4rem 0.4rem
  .el-popover
    margin-right: 0.4rem !important
</style>



// WEBPACK FOOTER //
// src/pages/knowledge/knowledge_hierarchy.vue